export const t = (key: string | undefined): string => (key ? key : "");
